<div class="dropdown" ngbDropdown container="body" display="dynamic">
  <button
    type="button"
    ndt-icon-button
    ngbDropdownToggle
    class="text-white hover:opacity-75 hidden lg:inline-flex"
    id="modules-menu-toggling-btn"
    aria-controls="modules-menu"
    aria-label="Wybór modułu"
    i18n-aria-label
  >
    <app-icon name="bars"></app-icon>
  </button>
  <ul id="modules-menu" class="dropdown-menu" aria-labelledby="modules-menu-toggling-btn" ngbDropdownMenu role="menu">
    <ng-container *ngFor="let item of items">
      <li *ngIf="item.permission | hasPermission" role="menuitem">
        <a class="dropdown-item inline-flex justify-between gap-2" [routerLink]="item.route">
          {{ item.label }} <app-icon [name]="item.icon"></app-icon>
        </a>
      </li>
    </ng-container>
  </ul>
</div>
